export default __webpack_public_path__ + "static/media/chatGPT.79e0c0da.svg";